import { IDeal } from 'store/deals/types';
import { IFieldOption } from 'store/field-options/types';
import { mapNameToDisplayName } from 'lib/helpers/field-options';
import { formatNumber } from 'lib/helpers/currency';
import { TNullableFloat } from 'store/deal-evaluation/types';

const formatCostToServeConst = 2;

export function updateDealWithAllProduct(deal: IDeal, availableProducts: IFieldOption[] | undefined) {
  const productObj = {
    name: 'All Products',
    selected: true,
  };
  const productNames: { name: string; selected: boolean }[] = [];
  const { products } = deal;
  if (products && products.length > 0) {
    products.forEach((pd: { name: string }) => {
      if (pd.name) {
        const productName = availableProducts ? mapNameToDisplayName(pd.name, availableProducts) : pd.name;
        productNames.push({
          name: productName,
          selected: false,
        });
      }
    });
  }
  const updateProductName = productNames.length > 1 ? [productObj, ...productNames] : productNames;
  return {
    ...deal,
    productName: updateProductName,
  };
}

export const getValueWithCurrency = (
  isCurrency: boolean,
  volume: number | undefined | null,
  value: number | undefined | null,
  decimalPlaces = 0
) => {
  if (!value) {
    return '-';
  }
  if (volume === null || volume === undefined) {
    return '-';
  }
  return isCurrency ? formatNumber(volume * value, decimalPlaces, true) : formatNumber(value, decimalPlaces, true);
};

export const getValueWithCurrencyUnFormatted = (isCurrency: boolean, volume: number, value: number) => {
  if (!value) {
    return 0;
  }
  return isCurrency ? volume * value : value;
};

export const formatCostToServe = (costToServe: TNullableFloat) => {
  if (!costToServe) {
    return '-';
  }
  const formattedYield = Math.abs(costToServe).toFixed(formatCostToServeConst);
  return costToServe < 0 ? `(${formattedYield}x)` : `${formattedYield}x`;
};
